import {useIntl} from 'react-intl';
import React from 'react';
import {
  Table
} from 'react-lib/frameworks/Table'

const PeriodontiumHistory = (props: any) => {
    const intl = useIntl();
    const isMounted = React.useRef(true);

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        style={{ width: "100%", height: "100%", padding: "10px" }}>
        <div
          style={{ paddingBottom: "5px", marginBottom:"10px", color: "rgba(0,0,0,0.87)", fontWeight: "bold", fontSize: "1.2em", borderBottom: "1px solid rgb(212, 212, 213)" }}>
          {intl.formatMessage({id: "cukey158"})}
        </div>
        <Table
          columns={props.historyColumn}
          data={props.periodontiumHistoryList}
          showPagination={false}
          style={{height:"300px"}}>
        </Table>
      </div>
    )
}

export default PeriodontiumHistory

export const screenPropsDefault = {}

/* Date Time : Fri May 21 2021 10:21:32 GMT+0000 (Coordinated Universal Time)
/* Original screen Data **************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", padding: \"10px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey158"})}
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\", marginBottom:\"10px\", color: \"rgba(0,0,0,0.87)\", fontWeight: \"bold\", fontSize: \"1.2em\", borderBottom: \"1px solid rgb(212, 212, 213)\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 89,
      "name": "Table",
      "parent": 0,
      "props": {
        "columns": {
          "type": "code",
          "value": "props.historyColumn"
        },
        "data": {
          "type": "code",
          "value": "props.periodontiumHistoryList"
        },
        "headers": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"300px\"}"
        }
      },
      "seq": 89,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 40,
  "isMounted": true,
  "memo": false,
  "name": "PeriodontiumHistory",
  "project": "cudent",
  "screenPropsDefault": {
  },
  "width": 55
}

************************************************************************************* */
